import { messages } from "@/shared/i18n";

export const CLIENT_CONSENT_ERROR_CODES: Record<string, string> = {
  "ClientAuthorization.UnknownClient": messages.clientConsent.errors.unknownClient,
};
